import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiDataResponse, ApiResponse, ReportGenerationApiResponse } from '../../../shared/model/api-response.model';

@Injectable({
  providedIn: 'root'
})

export class AdminService {
  http: HttpClient;

  constructor(http: HttpClient) {
    this.http = http;
  }

  getErrorLogs() {
    return this.http.get("/Admin/GetErrorLogs").toPromise();
  }

  exportErrorLog() {
    let url = "/Admin/ExportErrorLog";
    window.location.href = url;
    return true;
  }

  getConfigCat() {
    return this.http.get("/Admin/GetConfigCat").toPromise();
  }

  getLoginUrl(selectedCompany: any) {
    return this.http.get("/Admin/GetLoginUrl?co=" + selectedCompany, { responseType: 'text' }).pipe();
  }

  getUserGroup() {
    return this.http.get("/Admin/GetUserGroup").toPromise();
  }

  getAllEmailTemplates() {
    return this.http.get("/Admin/GetAllEmailTemplates").toPromise();
  }

  getLookup() {
    return this.http.get("/Checklist/GetLookup").toPromise();
  }

  getAttachmentTypes() {
    return this.http.get("/Checklist/GetAttachmentTypes").toPromise();
  }

  getUSStates() {
    return this.http.get("/Applicant/GetStates?countryCode=US").toPromise();
  }

  getCompanies() {
    return this.http.get("/Admin/GetCompanies").toPromise();
  }

  getVersionNumber() {
    return this.http.get("/Admin/GetVersionNumber").toPromise();
  }

  getCustomerId() {
    return this.http.get("/Admin/GetCustomerId").toPromise();
  }

  getPortalSettings() {
    return this.http.get("/Admin/GetPortalSettings").toPromise();
  }

  getAllPortalSettings() {
    return this.http.get("/Admin/GetAllPortalSettings").toPromise();
  }

  getPortalSettingUpdateLogs(portalSetting: string, count: number) {
    return this.http.get("/Admin/GetPortalSettingUpdateLogs?portalSetting=" + portalSetting + "&count=" + count).toPromise();
  }

  savePortalSettings(configName: any, configValue: any) {
    return this.http.post("/Admin/SavePortalSettings",
      {
        settingName: configName,
        settingValue: configValue
      }).toPromise();
  }

  portalSettingsPageData() {
    return this.http.get("/Admin/PortalSettingsPageData").toPromise();
  }

  getVersionHistory() {
    return this.http.get("/Admin/GetVersionHistory").toPromise();
  }

  sendUsageDataTask() {
    return this.http.post("/Admin/SendUsageDataTask", {}).toPromise();
  }

  refreshPortalSettings() {
    return this.http.post("/Admin/RefreshPortalSettings", {}).toPromise();
  }

  refreshSynonyms() {
    return this.http.post("/Admin/RefreshSynonyms", {}).toPromise();
  }

  refreshDynamicViews() {
    return this.http.post("/Admin/RefreshDynamicViews", {}).toPromise();
  }

  purgeVCMSessions() {
    return this.http.post("/Admin/PurgeVCMSessions", {}).toPromise();
  }

  previewUserGroupMembers(userGroupID: any, isUpdatePersist: any) {
    return this.http.get("/Admin/PreviewUserGroupMembers?userGroupID=" + userGroupID + "&isUpdatePersist=" + isUpdatePersist).toPromise();
  }

  checkExistRDL(filename: any) {
    return this.http.post("/Admin/CheckExistRDL",
      {
        filename: filename
      }).toPromise();
  }

  uploadCustomRDL(configName: any, configValue: any, fileData: any) {
    return this.http.post("/Admin/UploadCustomRDL",
      {
        settingName: configName,
        settingValue: configValue,
        fileData: fileData
      }).toPromise();
  }

  deleteCustomRDL(filename: any, configName: any) {
    return this.http.post("/Admin/DeleteCustomRDL",
      {
        filename: filename,
        settingName: configName
      }).toPromise();
  }

  builderCustomRDLAction(fileName: any, fileData: any, deleteList: any) {
    return this.http.post("/Admin/BuilderCustomRDLAction",
      {
        fileName: fileName,
        fileData: fileData,
        deleteList: deleteList
      }).toPromise();
  }

  updateConfigInfo(configName: any, description: any, helperText: any, isAdvanced: any, moduleSubID: any, defaultValue: any, regularExpression: any) {
    return this.http.post("/Admin/UpdateConfigInfo",
      {
        configName: configName,
        description: description,
        helperText: helperText,
        isAdvanced: isAdvanced,
        moduleSubID: moduleSubID,
        defaultValue: defaultValue,
        regularExpression: regularExpression
      }).toPromise();
  }

  birdDogTalentUserInsert() {
    return this.http.post("/Hiring/BirdDogTalentUserInsert", {}).toPromise();
  }

  deleteTempFilesAction() {
    return this.http.post("/Document/DeleteTempFilesAction", {}).toPromise();
  }

  clearCoLogoCache() {
    return this.http.post("/Company/ClearCoLogoCache", {}).toPromise();
  }

  getBulletinType(bulletinGroupType?: string) {
    return this.http.get("/Admin/GetBulletinType?bulletinGroupType=" + bulletinGroupType).toPromise();
  }

  getAllBulletinType() {
    return this.http.get("/Admin/GetBulletinType").toPromise();
  }

  getBulletinsManage() {
    return this.http.get("/Admin/GetBulletinsManage").toPromise();
  }

  deleteBulletin(bulletinID: number) {
    return this.http.post("/Admin/DeleteBulletin",
      {
        bulletinID: bulletinID
      }).toPromise();
  }

  bulletinSendPendingReminder(bulletinID: number) {
    return this.http.post("/Admin/BulletinSendPendingReminder",
      {
        bulletinID: bulletinID
      }).toPromise();
  }

  getDBAttachment(BulletinThumbFileAttachmentID: any) {//TODo Move to DocumentService
    return this.http.get("/Document/GetDBAttachment?attachmentID=" + BulletinThumbFileAttachmentID).toPromise();
  }

  getDBAttachmentList(moduleID: number, bulletinID?: number, recordGuid?: any, onboardingUser?: boolean) {//TODo Move to DocumentService
    return this.http.get("/Document/GetDBAttachmentList?moduleID=" + moduleID + "&recordID=" + bulletinID + "&recordGuid=" + recordGuid + "&onboardingUser=" + onboardingUser).toPromise();
  }

  addEditBulletin(requestObj: { [key: string]: any; }) {
    return this.http.post("/Admin/AddEditBulletin",
      {
        bulletinID: requestObj.bulletinID,
        bulletinAttachDocumentFlagValue: requestObj.bulletinAttachDocumentFlagValue,
        bulletinHeadline: requestObj.bulletinHeadline,
        bulletinBody: requestObj.bulletinBody,
        bulletinExpiresString: requestObj.bulletinExpiresString,
        bulletinThumbnailText: requestObj.bulletinThumbnailText,
        bulletinThumbFileAttachmentID: requestObj.bulletinThumbFileAttachmentID,
        bulletinMode: requestObj.bulletinMode,
        bulletinTypeID: requestObj.bulletinTypeID,
        bulletinDirectURL: requestObj.bulletinDirectURL,
        bulletinStartDateStr: requestObj.bulletinStartDateStr,
        embedAttachmentInPage: requestObj.embedAttachmentInPage,
        bulletinIgnoreDateString: requestObj.bulletinIgnoreDateString,
        bulletinSignatureText: requestObj.bulletinSignatureText,
        bulletinIsPinned: requestObj.bulletinIsPinned,
        attachmentType: requestObj.attachmentType,
        bulletinIsSecure: requestObj.bulletinIsSecure,
        isFillablePDF: requestObj.isFillablePDF,
        hasSecondStep: requestObj.hasSecondReviewStep,
        isStateForm: requestObj.isStateForm,
        state: requestObj.state,
        prefillPersonalData: requestObj.prefillPersonalData,
        disabledRequiredFields: requestObj.disabledRequiredFields,
      }).toPromise();
  }

  getBulletinGroup(bulletinTypeID?: number, bulletinID?: number) {
    return this.http.get("/Admin/GetBulletinGroup?bulletinTypeID=" + bulletinTypeID + "&bulletinID=" + bulletinID).toPromise();
  }

  setBulletinGroup(bulletinTypeID?: number, bulletinID?: number, userGroupID?: number) {
    return this.http.post("/Admin/SetBulletinGroup", {
      bulletinTypeID: bulletinTypeID,
      bulletinID: bulletinID,
      userGroupID: userGroupID
    }).toPromise();
  }

  removeBulletinGroup(userGroupBulletinTypeID: number) {
    return this.http.post("/Admin/RemoveBulletinGroup", {
      userGroupBulletinTypeID: userGroupBulletinTypeID
    }).toPromise();
  }

  saveDBAttachment(moduleID, recordID, attachmentFileData, attachmentFileName) {
    return this.http.post("/Document/SaveDBAttachment", {
      moduleID: moduleID,
      recordID: recordID,
      attachmentFileData: attachmentFileData,
      attachmentFileName: attachmentFileName
    }).toPromise();
  }

  userGroupAddSingleUser(userGroupID: number, userGroupName: any, fliterInactive: boolean, sQLQueryOverride: any, pRCo: any, memberType: string, isIncluded: boolean, groupValue: any) {
    return this.http.post("/Admin/UserGroupAddSingleUser", {
      userGroupID: userGroupID,
      userGroupName: userGroupName,
      fliterInactive: fliterInactive,
      sQLQueryOverride: sQLQueryOverride,
      pRCo: pRCo,
      memberType: memberType,
      isIncluded: isIncluded,
      groupValue: groupValue
    }).toPromise();
  }

  removeBulletinType(bulletinTypeID: number) {
    return this.http.post("/Admin/RemoveBulletinType", {
      bulletinTypeID: bulletinTypeID
    }).toPromise();
  }

  setBulletinType(bulletinTypeID: number, bulletinName: string, bulletinGroupType: string) {
    return this.http.post("/Admin/SetBulletinType", {
      bulletinTypeID: bulletinTypeID, bulletinName: bulletinName, bulletinGroupType: bulletinGroupType
    }).toPromise();
  }

  getBulletinTrackResponses(bulletinID?: number, pREHKeyID?: number) {
    return this.http.get("/Admin/GetBulletinTrackResponses?bulletinID=" + bulletinID + "&pREHKeyID=" + pREHKeyID).toPromise();
  }

  bulletinAttachToVista(bulletinID: number, bulletinAttachDocumentFlagValue: string, filename: string, PREHKeyID?: number, HRRMKeyID?: number, bulletinResponseID?: number) {
    return this.http.post("/Employee/BulletinAttachToVista", {
      bulletinID: bulletinID, bulletinAttachDocumentFlagValue: bulletinAttachDocumentFlagValue, filename: filename, PREHKeyID: PREHKeyID, HRRMKeyID: HRRMKeyID, bulletinResponseID: bulletinResponseID
    }).toPromise();
  }

  getHRUsers(searchText: string, includeInactive: boolean, userKeyID: number) {
    var url = "/Admin/GetHRUsers?searchText=" + searchText + "&includeInactive=" + includeInactive + "&userKeyID=" + userKeyID;
    return this.http.get(url).toPromise();
  }

  getBulletinsGetIndex(bulletinID?: number) {
    var url = "/Employee/GetBulletinsGetIndex?bulletinID=" + bulletinID;
    return this.http.get(url).toPromise();
  }

  getEmployees(includeInactive: boolean, isAdd: boolean, jcjm: number) {
    var url = "/Admin/GetEmployees?includeInactive=" + includeInactive + "&isAdd=" + isAdd + "&jcjm=" + jcjm;
    return this.http.get(url).toPromise();
  }

  getCodes(selectedCompany: number) {
    var url = "/Admin/GetCodes?hRCo=" + selectedCompany;
    return this.http.get(url).toPromise();
  }

  getScheduledJobs() {
    var url = "/Admin/GetScheduledJobs";
    return this.http.get(url).toPromise();
  }

  getScheduledJob(jobID: number) {
    var url = "/Admin/GetScheduledJob?JobID=" + jobID;
    return this.http.get(url).toPromise();
  }

  getScheduledJobHistory(jobID: number) {
    var url = "/Admin/ScheduledJobHistory?jobID=" + jobID;
    return this.http.get(url).toPromise();
  }

  addOrUpdateScheduledJob(job) {
    var url = "/Admin/AddOrUpdateScheduledJob";
    return this.http.post(url, job).toPromise();
  }

  removeUserDefinedJob(jobID: number) {
    var url = "/Admin/RemoveUserDefinedJob";
    return this.http.post(url, { jobID: jobID }).toPromise();
  }

  executeJobNow(jobID: number) {
    var url = "/Admin/ExecuteJobNow";
    return this.http.post(url, { jobID: jobID }).toPromise();
  }

  sendSMSUserGrouop(userGroupID?: number, sMSSubject?: string, bodyText?: string, messageType?: string, includeOptOut?: boolean, scheduledSendDateStr?: string, scheduleTimeStr?: string) {
    return this.http.post("/Admin/SendSMSUserGrouop", {
      userGroupID: userGroupID,
      sMSSubject: sMSSubject,
      bodyText: bodyText,
      messageType: messageType,
      includeOptOut: includeOptOut,
      scheduledSendDateStr: scheduledSendDateStr,
      scheduleTimeStr: scheduleTimeStr
    }).toPromise();
  }

  getMailLog(requestParam: string) {
    var url = "/Admin/GetMailLog?" + requestParam;
    return this.http.get(url).toPromise();
  }

  getMailQueueProcessSources() {
    var url = "/Admin/GetMailQueueProcessSources";
    return this.http.get(url).toPromise();
  }

  getHangFireEmailStatus() {
    var url = "/Admin/GetHangFireEmailStatus";
    return this.http.get(url).toPromise();
  }

  sendEmailQueueHourly(type: string) {
    return this.http.post("/Admin/SendEmailQueueHourly", {
      type: type
    }).toPromise();
  }

  deleteMailQueueItem(mailQueueID: number) {
    return this.http.post("/Admin/DeleteMailQueueItem", {
      mailQueueID: mailQueueID
    }).toPromise();
  }

  sendTestEmail(mailTo: string) {
    var url = "/Admin/SendTestEmail";
    return this.http.post(url, { mailTo: mailTo }).toPromise();
  }

  forwardEmail(mailQueueID: number, mailTo: string) {
    return this.http.post("/Admin/ForwardEmail", {
      mailQueueID: mailQueueID,
      toEmail: mailTo
    }).toPromise();
  }

  getTrainingCompany() {
    var url = "/Employee/GetTrainingCompany";
    return this.http.get(url).toPromise();
  }

  getClassesToManage(hRCo: number, showTemplates: boolean, trainingClassID?: any) {
    var url = "/Admin/GetClassesToManage?hRCo=" + hRCo + "&showTemplates=" + showTemplates + "&trainingClassID=" + trainingClassID;
    return this.http.get(url).toPromise();
  }

  getChecklistTemplate(checklistTemplateCatgID?: number) {
    var url = "/Admin/GetChecklistTemplate?checklistTemplateCatgID=" + checklistTemplateCatgID;
    return this.http.get(url).toPromise();
  }

  getRequireCourseSetting() {
    var url = "/Admin/GetRequireCourseSetting";
    return this.http.get(url).toPromise();
  }

  addGroupToClass(trainingClassId: number, userGroupID: number) {
    return this.http.post("/Admin/AddGroupToClass", {
      trainingClassId: trainingClassId,
      userGroupID: userGroupID
    }).toPromise();
  }

  removeGroupFromClass(trainingClassId: number, userGroupID: number) {
    return this.http.post("/Admin/RemoveGroupFromClass", {
      trainingClassId: trainingClassId,
      userGroupID: userGroupID
    }).toPromise();
  }

  hasCompletedChecklist(trainingClassID: number, hasCompletedChecklist: boolean) {
    return this.http.post("/Admin/HasCompletedChecklist", {
      trainingClassID: trainingClassID,
      hasCompletedChecklist: hasCompletedChecklist
    }).toPromise();
  }


  addAttendeeToClass(trainingClassId: any, attendeeUserKeyID: any) {
    return this.http.post("/Admin/AddAttendeeToClass", {
      trainingClassId: trainingClassId,
      attendeeUserKeyID: attendeeUserKeyID
    }).toPromise();
  }

  getGroups() {
    var url = "/Admin/GetUserGroup"
    return this.http.get(url).toPromise();
  }

  removeAttendee(trainingClassAttendeeID: number, trainingClassId: number) {
    return this.http.post("/Admin/RemoveAttendee", {
      trainingClassAttendeeID: trainingClassAttendeeID,
      trainingClassId: trainingClassId
    }).toPromise();
  }

  addCodeToClass(trainingClassId: number, hRCMKeyID: number) {
    return this.http.post("/Admin/AddCodeToClass", {
      trainingClassId: trainingClassId,
      hRCMKeyID: hRCMKeyID
    }).toPromise();
  }

  removeCode(data: { trainingClassId: number; hRCMKeyID: number; }) {
    return this.http.post("/Admin/RemoveCode", {
      trainingClassId: data.trainingClassId,
      hRCMKeyID: data.hRCMKeyID
    }).toPromise();
  }

  createEditClass(data: { [key: string]: any }) {
    return this.http.post("/Admin/CreateEditClass", {
      trainingClassId: data.trainingClassId,
      classDateTimeStr: data.classDateTimeStr,
      classTitle: data.classTitle,
      isClassOpenRegister: data.isClassOpenRegister,
      classInstructorUserKeyID: data.classInstructorUserKeyID,
      hRCo: data.hRCo,
      location: data.location,
      maxAttendeeCount: data.maxAttendeeCount,
      classEndDateTimeStr: data.classEndDateTimeStr,
      checklistTemplateID: data.checklistTemplateID,
      isClassTemplate: data.isClassTemplate,
      templateTrainingClassID: data.templateTrainingClassID,
      expirationDateStr: data.expirationDateStr
    }).toPromise();
  }

  finalizeClass(trainingClassId: number, isFinalized: number, checklistInstanceID?: number) {
    return this.http.post("/Admin/FinalizeClass", {
      trainingClassId: trainingClassId,
      isFinalized: isFinalized,
      checklistInstanceID: checklistInstanceID
    }).toPromise();
  }

  deleteSavedAttachment(file: any) {
    return this.http.post("/Employee/RemoveFileAttachment", {
      fileAttachmentID: file.FileAttachmentID
    }).toPromise();
  }

  getGroupByClass(trainingClassId: number) {
    var url = "/Admin/GetGroupByClass?trainingClassId=" + trainingClassId;
    return this.http.get(url).toPromise();
  }

  getCodesByClass(trainingClassId: number) {
    var url = "/Admin/GetCodesByClass?trainingClassId=" + trainingClassId;
    return this.http.get(url).toPromise();
  }

  getAttendeesByClass(trainingClassId: number) {
    var url = "/Admin/GetAttendeesByClass?trainingClassId=" + trainingClassId;
    return this.http.get(url).toPromise();
  }

  getAttendees() {
    var url = "/Admin/GetAttendees";
    return this.http.get(url).toPromise();
  }

  attendeeSign(trainingClassAttendeeID: number, isPresent: boolean, signatureData?: any, signatureLong?: any, signatureLat?: any) {
    return this.http.post("/Admin/AttendeeSign", {
      trainingClassAttendeeID: trainingClassAttendeeID,
      isPresent: isPresent,
      signatureData: signatureData,
      signatureLong: signatureLong,
      signatureLat: signatureLat
    }).toPromise();
  }

  attendeeMarkAllPresent(trainingClassID: number) {
    return this.http.post("/Admin/AttendeeMarkAllPresent", { trainingClassID: trainingClassID }).toPromise();
  }

  deleteClass(trainingClassId: number) {
    return this.http.post("/Admin/DeleteClass", {
      trainingClassId: trainingClassId
    }).toPromise();
  }

  getHolidayGroupSet() {
    const url = "/Admin/HolidayGroupsGet";
    return this.http.get(url).toPromise();
  }

  getHolidayCodeAssign(holidayGroupID: number) {
    const url = "/Admin/HolidayCodeAssignGet?holidayGroupID=" + holidayGroupID;
    return this.http.get(url).toPromise();
  }

  getHolidayList(selectedYear: number, selectedCountry: string) {
    const url = "/Admin/GetHolidayList?year=" + selectedYear + "&country=" + selectedCountry;
    return this.http.get(url).toPromise();
  }

  getUserGroupList() {
    const url = "/Admin/GetUserGroup";
    return this.http.get(url).toPromise();
  }

  addUserGroup(holidayGroupID: number, userGroupID: number) {
    const url = "/Admin/HolidayCodeAssignAdd";
    const payload = {
      holidayGroupID: holidayGroupID,
      userGroupID: userGroupID
    }
    return this.http.post(url, payload).toPromise();
  }

  addHolidayGroupName(groupData) {
    const url = "/Admin/HolidayGroupAddUpdate";
    const payload = {
      holidayGroupID: groupData.holidayGroupID,
      holidayGroupName: groupData.holidayGroupName
    }
    return this.http.post(url, payload).toPromise();
  }

  updateHolidayGroupName(groupData) {
    const url = "/Admin/HolidayGroupAddUpdate";
    const payload = {
      holidayGroupID: groupData.holidayGroupID,
      holidayGroupName: groupData.holidayGroupName
    }
    return this.http.post(url, payload).toPromise();
  }

  removeUserGroup(userGroup) {
    const url = "/Admin/HolidayCodeAssignDelete";
    const payload = {
      holidayCodeAssignID: userGroup.HolidayCodeAssignID
    }
    return this.http.post(url, payload).toPromise();
  }

  deleteGroup(holidayGroup) {
    const url = "/Admin/HolidayGroupDelete";
    const payload = { holidayGroupID: holidayGroup.HolidayGroupID }
    return this.http.post(url, payload).toPromise();
  }

  addHoliday(holidayData) {
    const url = "/Admin/HolidayAddEdit";
    const payload = {
      holidayID: holidayData.holidayID,
      holidayGroupID: holidayData.holidayGroupID,
      holidayDateStr: holidayData.holidayDateStr,
      holidayName: holidayData.holidayName,
      holidayDescription: holidayData.holidayDescription,
      isPartialDay: holidayData.isPartialDay
    }
    return this.http.post(url, payload).toPromise();
  }

  deleteHoliday(holiday) {
    const url = "/Admin/HolidayDelete";
    const payload = {
      holidayID: holiday.HolidayID
    }
    return this.http.post(url, payload).toPromise();
  }

  getHolidayByGroupID(holidayGroupID: number) {
    const url = "/Admin/HolidaysGetByGroupID?holidayGroupID=" + holidayGroupID;
    return this.http.get(url).toPromise();
  }

  getPRGroups(company: any) {
    return this.http.get("/Admin/GetPRGroups?company=" + company).toPromise();
  }

  getEmployeesByPRCoAndPRGroup(pRCo: any, pRGroup: any) {
    return this.http.get("/Admin/GetEmployeesByPRCoAndPRGroup?pRCo=" + pRCo + "&pRGroup=" + pRGroup).toPromise();
  }

  getVistaVersion() {
    var url = "/Admin/GetVistaVersion";
    return this.http.get(url).toPromise();
  }

  getEmailTemplates(emailTemplateID?: number, reqID?: any) {
    var url = "/Admin/GetEmailTemplates?reqID=" + reqID;
    return this.http.get(url).toPromise();
  }

  evaluateEmailTemplateVerbiage(onboardID?: any, reqID?: any, emailTemplateID?: number, templateBody?: string, templateSubject?: string, sendEmail?: boolean, templateTo?: string) {
    var url = "/Admin/EvaluateEmailTemplateVerbiage?onboardID=" + onboardID + "&reqID=" + reqID + "&emailTemplateID=" + emailTemplateID;
    return this.http.get(url).toPromise();
  }

  getAvailableFields() {
    return this.http.get("/Admin/GetAvailableFields").toPromise();
  }

  getTrackingTypes() {
    return this.http.get("/Admin/GetTrackingTypes").toPromise();
  }

  getUpdateModes(fieldId: number) {
    var url = "/Admin/GetUpdateModes?fieldId=" + fieldId;
    return this.http.get(url).toPromise();
  }

  getFields() {
    return this.http.get("/Admin/GetFields").toPromise();
  }

  addField(fieldName: string, viewName: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    var options = { headers: headers };
    return this.http.post("/Admin/AddField", {
      fieldName: fieldName,
      viewName: viewName
    }, options).toPromise();
  }

  updateField(fieldId: number, updateMode: number, trackingType: number, fieldOverride: string, isRequiredForBenefits?: boolean, validationRegex?: string, fieldRequiredAttachmentOnChange?: boolean) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    var options = { headers: headers };
    return this.http.post("/Admin/UpdateField", {
      fieldId: fieldId,
      updateMode: updateMode,
      trackingType: trackingType,
      fieldOverride: fieldOverride,
      isRequiredForBenefits: isRequiredForBenefits,
      validationRegex: validationRegex,
      fieldRequiredAttachmentOnChange: fieldRequiredAttachmentOnChange
    }, options).toPromise();
  }

  removeField(fieldId: number) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    var options = { headers: headers };
    return this.http.post("/Admin/RemoveField", {
      fieldId: fieldId
    }, options).toPromise();
  }

  moveField(fieldId: number, direction: number) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    var options = { headers: headers };
    return this.http.post("/Admin/MoveField", {
      fieldId: fieldId,
      direction: direction
    }, options).toPromise();
  }

  getCMList(pRPCKeyID: number) {
    var url = "/Admin/GetCMList?pRPCKeyID=" + pRPCKeyID;
    return this.http.get(url).toPromise();
  }

  getOptOutDetails(year: number, pRCo: number, docType: string, filterType: string) {
    var url = "/Document/GetOptOutDetails?year=" + year + "&pRCo=" + pRCo + "&docType=" + docType + "&filterType=" + filterType;
    return this.http.get(url).toPromise();
  }

  prepareOptOutDoc(year: number, pRCo: number, docType: string, filterType: string, employee?: number): Observable<ReportGenerationApiResponse> {
    return this.http.post<ReportGenerationApiResponse>("/Document/PrepareOptOutDoc", {
      year: year,
      pRCo: pRCo,
      docType: docType,
      filterType: filterType,
      employee: employee
    });
  }

  getCompanyGroups(pRCo: number) {
    var url = "/Admin/GetCompanyGroups?PRCo=" + pRCo;
    return this.http.get(url).toPromise();
  }

  getPayPeriods(companyId: number, groupId: number, showOnlyOptOutPeriods?: boolean) {
    var url = "/Admin/GetPayPeriods?companyId=" + companyId + "&groupId=" + groupId + "&showOnlyOptOutPeriods=" + showOnlyOptOutPeriods;
    return this.http.get(url).toPromise();
  }

  getPaystubCount(payPeriodId: number) {
    var url = "/Admin/GetPaystubCount?payPeriodId=" + payPeriodId;
    return this.http.get(url).toPromise();
  }

  scheduleGet() {
    return this.http.get("/Admin/ScheduleGet").toPromise();
  }

  scheduleRemove(payStubNotifierID?: number) {
    return this.http.post("/Admin/ScheduleRemove", {
      payStubNotifierID: payStubNotifierID
    }).toPromise();
  }

  scheduleAdd(pRCo?: number, pRGroup?: number, messageType?: string) {
    return this.http.post("/Admin/ScheduleAdd", {
      pRCo: pRCo,
      pRGroup: pRGroup,
      messageType: messageType
    });
  }

  sendSMS(pRPCKeyID: number, cMRef: string, sendSMS?: boolean, isSentFromAutoNotifier?: boolean) {
    return this.http.post("/Admin/SendSMS", {
      pRPCKeyID: pRPCKeyID,
      cMRef: cMRef,
      sendSMS: sendSMS,
      isSentFromAutoNotifier: isSentFromAutoNotifier
    }).toPromise();
  }


  getProfileCompanies() {
    return this.http.get("/Admin/GetProfileCompanies").toPromise();
  }

  getHRCompany() {
    return this.http.get("/Admin/GetHRCompany").toPromise();
  }

  getBenefitGroupMembers(hRBGKeyID: number, showIndividualsOrGroups: string) {
    var url = "/Admin/GetBenefitGroupMembers?hRBGKeyID=" + hRBGKeyID + "&showIndividualsOrGroups=" + showIndividualsOrGroups;
    return this.http.get(url).toPromise();
  }

  addBenefitGroupMember(requestObj: any) {
    return this.http.post("/Admin/AddBenefitGroupMember",
      {
        hRBGKeyID: requestObj.hRBGKeyID,
        pRCo: requestObj.pRCo,
        memberType: requestObj.memberType,
        isIncluded: requestObj.isIncluded,
        groupValue: requestObj.groupValue,
        hideResults: requestObj.hideResults
      }).toPromise();
  }

  getBenefitGroups(hRCo: number) {
    var url = "/Admin/GetBenefitGroups?hRCo=" + hRCo;
    return this.http.get(url).toPromise();
  }

  getPRCoByHRCo(hRCo: number) {
    var url = "/Admin/GetPRCoByHRCo?hRCo=" + hRCo;
    return this.http.get(url).toPromise();
  }

  getEmployeesByHRCo(hRCo: number, searchString: string) {
    var url = "/Admin/GetEmployeesByHRCo?hRCo=" + hRCo + "&searchString=" + searchString;
    return this.http.get(url).toPromise();
  }

  removeBenefitGroupMember(hRBGKeyID: number, benefitGroupmemberID: number, hideResults: boolean = false) {
    return this.http.post("/Admin/RemoveBenefitGroupMember",
      {
        hRBGKeyID: hRBGKeyID,
        benefitGroupmemberID: benefitGroupmemberID,
        hideResults: hideResults
      }).toPromise();
  }

  clearBenefitGroupMembers(hRBGKeyID: number, hideResults: boolean = false) {
    return this.http.post("/Admin/ClearBenefitGroupMembers",
      {
        hRBGKeyID: hRBGKeyID,
        hideResults: hideResults
      }).toPromise();
  }

  previewBenefitGroupMembers(hRBGKeyID: number, isUpdatePersist: boolean, hideResults: boolean = false) {
    var url = "/Admin/PreviewBenefitGroupMembers?hRBGKeyID=" + hRBGKeyID + "&isUpdatePersist=" + isUpdatePersist + "&hideResults=" + hideResults;
    return this.http.get(url).toPromise();
  }

  getTimecardCompanies(source?: string) {
    var url = "/Admin/GetTimecardCompanies?source=" + source;
    return this.http.get(url).toPromise();
  }

  getAllocationJobs(searchString: string) {
    var url = "/Admin/GetAllocationJobs?searchString=" + searchString;
    return this.http.get(url);
  }

  getAllocations(jCJMKeyID: number) {
    var url = "/Admin/GetAllocations?jCJMKeyID=" + jCJMKeyID;
    return this.http.get(url).toPromise();
  }

  getBatchesFrom(pRCo: number) {
    var url = "/Admin/GetBatchesFrom?pRCo=" + pRCo;
    return this.http.get(url).toPromise();
  }

  getBatchesTo(pRCo: number, pRGroup: number) {
    var url = "/Admin/GetBatchesTo?pRCo=" + pRCo + "&pRGroup=" + pRGroup;
    return this.http.get(url).toPromise();
  }

  getSafetyNetItems(hQBCKeyID: number) {
    var url = "/Admin/GetSafetyNetItems?hQBCKeyID=" + hQBCKeyID;
    return this.http.get(url).toPromise();
  }

  restoreSafetyNetItem(hQBCKeyID: number, items: string) {
    return this.http.post("/Admin/RestoreSafetyNetItem",
      {
        hQBCKeyID: hQBCKeyID,
        items: items
      }).toPromise();
  }

  getFailedUserAttempts(pRCo: number, startDate: string, endDate: string) {
    var url = "/Admin/GetFailedUserAttempts?pRCo=" + pRCo + "&timeStart=" + startDate + "&timeEnd=" + endDate;
    return this.http.get(url).toPromise();
  }

  getIPForEmployee(pRCo: number, employee: number) {
    var url = "/Admin/GetIPForEmployee?pRCo=" + pRCo + "&employee=" + employee;
    return this.http.get(url).toPromise();
  }

  getActiveSessions(pRCo: number, employee: number) {
    var url = "/Admin/GetActiveSessions?pRCo=" + pRCo + "&employee=" + employee;
    return this.http.get(url).toPromise();
  }

  getAllActiveSessions(pRCo: number) {
    var url = "/Admin/GetAllActiveSessions?pRCo=" + pRCo;
    return this.http.get(url).toPromise();
  }


  insertUpdateAllocation(allocationID: number, jCCo: number, job: any, employee: any, pRCo: number) {
    return this.http.post("/Admin/InsertUpdateAllocation", {
      allocationID: allocationID,
      jCCo: jCCo,
      job: job,
      employee: employee,
      pRCo: pRCo
    }).toPromise();
  }

  deleteAllocation(allocationID: number) {
    return this.http.post("/Admin/DeleteAllocation", {
      allocationID: allocationID
    }).toPromise();
  }

  pendingChanges(status: number, startDate: string, endDate: string) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    var options = { headers: headers };
    return this.http.post("/Admin/PendingChanges", {
      status: status,
      startDate: startDate,
      endDate: endDate
    }, options).toPromise();
  }

  processFieldUpdate(requestObject: any) {
    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    var options = { headers: headers };
    return this.http.post("/Admin/ProcessFieldUpdate", {
      fieldUpdateId: requestObject.fieldUpdateId,
      actionValue: requestObject.actionValue,
      newValue: requestObject.newValue,
      adminNotes: requestObject.adminNotes
    }, options).toPromise();
  }

  personalAttachAction(docSubmissionID: number, mode: string, adminNotes: string) {
    return this.http.post("/Admin/PersonalAttachAction",
      {
        docSubmissionID: docSubmissionID,
        mode: mode,
        adminNotes: adminNotes
      }).toPromise();
  }

  personalAttachUpdate(attachmentID: number[], descriptions: string[], moduleID: number[], attachmentType: string[]) {
    return this.http.post("/Admin/PersonalAttachUpdate",
      {
        AttachmentID: attachmentID,
        descriptions: descriptions,
        ModuleID: moduleID,
        AttachmentType: attachmentType
      }).toPromise();
  }

  getW4Detail(exemptUpdateID?: number) {
    var url = "/Admin/GetW4Detail?exemptUpdateID=" + exemptUpdateID;
    return this.http.get(url).toPromise();
  }

  w4AdminUpdate(requestObject: any) {
    return this.http.post("/Admin/W4AdminUpdate",
      {
        exemptUpdateID: requestObject.exemptUpdateID,
        mode: requestObject.mode,
        adminNotes: requestObject.adminNotes,
        fileName: requestObject.fileName,
        fileDescription: requestObject.fileDescription,
        HPR: requestObject.HPR,
        ct: requestObject.ct
      }).toPromise();
  }

  getDirectDepositUpdate(id?: number) {
    var url = "/Admin/GetDirectDepositUpdate?id=" + id;
    return this.http.get(url).toPromise();
  }

  processDirectDepositUpdate(requestObject: any) {
    return this.http.post("/Admin/ProcessDirectDepositUpdate",
      {
        directDepositUpdateID: requestObject.directDepositUpdateID,
        actionCode: requestObject.actionCode,
        note: requestObject.note,
        preHkeyID: requestObject.preHkeyID,
        attachment1: requestObject.attachment1,
        attachment2: requestObject.attachment2,
        attachment3: requestObject.attachment3,
        attachment4: requestObject.attachment4,
        attachmentFileName1: requestObject.attachmentFileName1,
        attachmentFileName2: requestObject.attachmentFileName2,
        attachmentFileName3: requestObject.attachmentFileName3,
        attachmentFileName4: requestObject.attachmentFileName4,
        attachmentDescription1: requestObject.attachmentDescription1,
        attachmentDescription2: requestObject.attachmentDescription2,
        attachmentDescription3: requestObject.attachmentDescription3,
        attachmentDescription4: requestObject.attachmentDescription4,
        HPR: requestObject.HPR
      }).toPromise();
  }

  removeEmployeeUserGroup(userGroupID: number) {
    return this.http.post("/Admin/RemoveUserGroup", {
      userGroupID: userGroupID
    }).toPromise();
  }

  userGroupMembersAddUpdate(userGroupID: number, userGroupName: string, sQLQueryOverride: string, fliterInactive?: boolean) {
    return this.http.post("/Admin/UserGroupMembersAddUpdate", {
      userGroupID: userGroupID,
      userGroupName: userGroupName,
      fliterInactive: fliterInactive,
      sQLQueryOverride: sQLQueryOverride
    }).toPromise();
  }

  getUserGroupMembers(userGroupID: number, showIndividualsOrGroups: string) {
    var url = "/Admin/GetUserGroupMembers?userGroupID=" + userGroupID + "&showIndividualsOrGroups=" + showIndividualsOrGroups;
    return this.http.get(url).toPromise();
  }

  getUserGroupMembersRefreshAll() {
    return this.http.get("/Admin/UserGroupMembersRefreshAll").toPromise();
  }

  addUserGroupMember(userGroupID: number, pRCo?: number, memberType?: string, isIncluded?: boolean, groupValue?: string) {
    return this.http.post("/Admin/AddUserGroupMember", {
      userGroupID: userGroupID,
      pRCo: pRCo,
      memberType: memberType,
      isIncluded: isIncluded,
      groupValue: groupValue
    }).toPromise();
  }

  removeUserGroupMember(userGroupMemberID: number, userGroupID: number) {
    return this.http.post("/Admin/RemoveUserGroupMember", {
      userGroupMemberID: userGroupMemberID,
      userGroupID: userGroupID
    }).toPromise();
  }

  clearUserGroupMembers(userGroupID: number) {
    return this.http.post("/Admin/ClearUserGroupMembers", {
      userGroupID: userGroupID
    }).toPromise();
  }

  getDynamicEmailFields() {
    var url = "/Admin/GetDynamicEmailFields"
    return this.http.get(url).toPromise();
  }

  addEditEmailTemplates(requestObject: any) {
    return this.http.post("/Admin/AddEditEmailTemplates", {
      emailTemplateID: requestObject.emailTemplateID,
      templateBody: requestObject.templateBody,
      templateSubject: requestObject.templateSubject,
      templateName: requestObject.templateName,
      isStandard: requestObject.IsStandard,
      templateTo: requestObject.TemplateTo,
      templateCC: requestObject.TemplateCC,
      templateBCC: requestObject.TemplateBCC,
      jCDMKeyID: requestObject.jCDMKeyID,
      sendAsSystem: requestObject.sendAsSystem
    }).toPromise();
  }

  deleteEmailTemplates(emailTemplateID?: number) {
    return this.http.post("/Admin/DeleteEmailTemplates", {
      emailTemplateID: emailTemplateID
    }).toPromise();
  }
  getLeaveRequestSummary(company: number, dateFromString: string, dateToString: string, status: string, onlyIsPendingForFilter: boolean, searchString: string) {
    var url = "/Admin/GetLeaveRequestSummary?company=" + company + "&dateFromString=" + dateFromString +
      "&dateToString=" + dateToString + "&status=" + status + "&onlyIsPendingForFilter=" + onlyIsPendingForFilter + "&searchString=" + searchString;
    return this.http.get(url).toPromise();
  }

  getRequestsByMonth(pRCo?: number, monthStr?: string, employee?: number) {
    var url = "/Admin/GetRequestsByMonth?pRCo=" + pRCo + "&monthStr=" + monthStr + "&employee=" + employee;
    return this.http.get(url).toPromise();
  }

  setScheduleChecked(leaveRequestID: number, udScheduleChecked: string) {
    return this.http.post("/Admin/SetScheduleChecked", {
      leaveRequestID: leaveRequestID,
      udScheduleChecked: udScheduleChecked
    }).toPromise();
  }

  leaveRequestUpdate(leaveRequestId: number, actionToPerform: string, keyID: number) {
    return this.http.post("/Admin/LeaveRequestUpdate?leaveRequestId", {
      leaveRequestId: leaveRequestId,
      actionToPerform: actionToPerform,
      KeyID: keyID
    }).toPromise();
  }

  getEmployeesByAuthToken() {
    var url = "/Admin/GetEmployeesByAuthToken";
    return this.http.get(url).toPromise();
  }

  getApproverListByPREHKeyID(pREHKeyID: number) {
    var url = "/Admin/GetApproverListByPREHKeyID?pREHKeyID=" + pREHKeyID;
    return this.http.get(url).toPromise();
  }

  getHRGroupAdmins() {
    var url = "/Admin/GetHRGroupAdmins";
    return this.http.get(url).toPromise();
  }

  addHRGroupAdmin(userId: number, company: number, group: number) {
    return this.http.post("/Admin/AddHRGroupAdmin", {
      userId: userId,
      company: company,
      group: group
    }).toPromise();
  }

  removeHRGroupAdmin(id: number) {
    return this.http.post("/Admin/RemoveHRGroupAdmin", {
      id: id
    }).toPromise();
  }

  updateHRGroupAdmin(id: number, notifyDaily: boolean, notifyRealTime: boolean, approve: boolean, vacation: boolean, isTimecardDashAdmin: boolean, isTimecardMoveAdmin: boolean, isVacationDashAdmin: boolean, isBulletinAdmin: boolean,
    isSecurityAdmin: boolean, isTrainingAdmin: boolean, isBenefitsAdmin: boolean, isVacationCalendar: boolean, isExpenseAdmin: boolean, isTrainingClassAdmin: boolean, isHRDocumentAdmin: boolean, isPRAdmin: boolean) {
    return this.http.post("/Admin/UpdateHRGroupAdmin", {
      id: id,
      notifyDaily: notifyDaily,
      notifyRealTime: notifyRealTime,
      approve: approve,
      vacation: vacation,
      isTimecardDashAdmin: isTimecardDashAdmin,
      isTimecardMoveAdmin: isTimecardMoveAdmin,
      isVacationDashAdmin: isVacationDashAdmin,
      isBulletinAdmin: isBulletinAdmin,
      isSecurityAdmin: isSecurityAdmin,
      isTrainingAdmin: isTrainingAdmin,
      isBenefitsAdmin: isBenefitsAdmin,
      isVacationCalendar: isVacationCalendar,
      isExpenseAdmin: isExpenseAdmin,
      isTrainingClassAdmin: isTrainingClassAdmin,
      isHRDocumentAdmin: isHRDocumentAdmin,
      isPRAdmin: isPRAdmin
    }).toPromise();
  }


  permissionItemsGet(dataType: string, permissionItemID?: number) {
    var url = "/Admin/PermissionItemsGet?dataType=" + dataType + "&permissionItemID=" + permissionItemID;
    return this.http.get(url).toPromise();
  }

  permissionAssignmentAdd(permissionItemID: string, userGroupID?: number, userKeyID?: number) {
    return this.http.post("/Admin/PermissionAssignmentAdd", {
      permissionItemID: permissionItemID,
      userGroupID: userGroupID,
      userKeyID: userKeyID
    }).toPromise();
  }

  permissionAssignmentsClear(permissionItemIDString: string) {
    return this.http.post("/Admin/PermissionAssignmentsClear", {
      permissionItemIDString: permissionItemIDString,
    }).toPromise();
  }

  permissionAssignmentDelete(permissionAssignID: number) {
    return this.http.post("/Admin/PermissionAssignmentDelete", {
      permissionAssignID: permissionAssignID,
    }).toPromise();
  }

  permissionAssignmentsGet(permissionItemID: number) {
    var url = "/Admin/PermissionAssignmentsGet?permissionItemID=" + permissionItemID;
    return this.http.get(url).toPromise();
  }

  permissionAssignmentsEffective(permissionItemID: number) {
    var url = "/Admin/PermissionAssignmentsEffective?permissionItemID=" + permissionItemID;
    return this.http.get(url).toPromise();
  }

  deleteDBAttachment(fileAttachmentID: string) {
    return this.http.post("/Document/DeleteDBAttachment", {
      fileAttachmentID: fileAttachmentID
    }).toPromise();
  }

  processFaceQueue() {
    return this.http.get("/Admin/ProcessFaceQueue").toPromise();
  }

  async getProvisionedLicenseCounts(): Promise<ProvisionedLicenseCounts> {
    return (await this.http.get<ProvisionedLicenseCounts>('/Admin/GetLicenseCount').toPromise())
  }

  async getActiveLicenseCounts(): Promise<ActiveLicenseCounts> {
    return await this.http.get<ActiveLicenseCounts>('/Admin/GetCounts').toPromise()
  }

  async getCompaniesForUserAccess(): Promise<Array<CompanyHQCo>> {
    return await this.http.get<Array<CompanyHQCo>>('/Admin/GetCompaniesForUserAccess').toPromise()
  }

  async getPRGroupsByCompanyId(companyId: number): Promise<Array<PRGroup>> {
    const url = "/Admin/GetPRGroups?company=" + companyId
    return await this.http.get<Array<PRGroup>>(url).toPromise()
  }

  async getEmployeeGroups(): Promise<Array<EmployeeGroup>> {
    return await this.http.get<Array<EmployeeGroup>>('/Admin/GetEmployeeGroups').toPromise()
  }

  async unlockUser (params: HttpParams): Promise<ApiResponse> {
    return await <Promise<ApiResponse>> this.http.post('/Admin/UnlockLogin', params).toPromise()
  }

  async linkVPID (company?: number, userKeyID?: number): Promise<ApiResponse> {
    return await <Promise<ApiResponse>> this.http.post('/Admin/LinkVistaSsoToHrUser', { PRCo: company, UserKeyID: userKeyID }).toPromise()
  }

  async unlinkVPID (userKeyID: number): Promise<ApiResponse> {
    return await <Promise<ApiResponse>>this.http.post('/Admin/UnlinkVistaSsoToHrUser', { UserKeyID: userKeyID }).toPromise()
  }

  async unlinkTID (prco:number, employee: number): Promise<ApiResponse> {
    return await <Promise<ApiResponse>>this.http.post('/Admin/SetTID', { prco: prco, employee: employee, tid: null }).toPromise()
  }

  async getUsers(params: HttpParams): Promise<User[]> {
    return await this.http.get<Promise<User[]>>('/Admin/GetUsers', { params }).toPromise()
  }

  async getReviewerGroups(): Promise<Array<ReviewerGroup>> {
    return await this.http.get<Array<ReviewerGroup>>('/Admin/GetReviewerGroups').toPromise()
  }

  async setBulkHours (params: HttpParams): Promise<ApiResponse> {
    return await <Promise<ApiResponse>> this.http.post('/Admin/BulkCheckBox', params).toPromise()
    }

  async getCounts(): Promise<ActiveLicenseCounts> {
    return await this.http.get<ActiveLicenseCounts>('/Admin/GetCounts').toPromise()
  }

  async clearUserGridSettings(params: HttpParams) {
    return await this.http.post('/Admin/ClearUserGridSettings', params).toPromise()
  }

  async sendWelcomeEmail(params: HttpParams) {
    return await this.http.post('/Admin/SendWelcomeEmail', params).toPromise()
  }

  async sendWelcomeEmailAll(params: HttpParams) {
    return await this.http.post('/Admin/SendWelcomeEmailAll', params).toPromise()
  }

  async sendMobileInvite(params: HttpParams) {
    return await this.http.post('/Admin/SendMobileInvite', params).toPromise()
  }

  async getUserGroups(): Promise<Array<UserGroup>> {
    return await this.http.get<Array<UserGroup>>('/Admin/GetUserGroup').toPromise()
  }

  async bulkApplyPOLicenseType(params: HttpParams) {
    return await this.http.post('/Admin/BulkApplyPOLicenseType', { params }).toPromise()
  }

  async bulkCheckBox(params: HttpParams) {
    return await this.http.post('/Admin/BulkCheckBox', params).toPromise()
  }

  async createNamedLogin (params: HttpParams): Promise<ApiResponse> {
    return await this.http.post<ApiResponse>('/Admin/CreateNamedLogin', params).toPromise()
  }

  async unlockNamedLogin(params: HttpParams) {
    return await this.http.post('/Admin/UnlockNamedLogin', params).toPromise()
  }

  async removeNamedLogin (params: HttpParams): Promise<ApiResponse> {
    return await this.http.post<ApiResponse>('/Admin/RemoveNamedLogin', params).toPromise()
  }

  async getNamedLoginList(): Promise<ApiDataResponse<Array<NamedLogin>>> {
    return await this.http.get<ApiDataResponse<Array<NamedLogin>>>('/Admin/GetNamedLoginList').toPromise()
  }

  async changeNamedLoginPassword (params: HttpParams): Promise<ApiResponse> {
    return await this.http.post<ApiResponse>("/Admin/ChangeNamedLoginPassword",
      params
    ).toPromise();
  }

  getOpenAdminTrans() {
    var url = "/Admin/GetOpenAdminTrans";
    return this.http.get(url).toPromise();
  }

  deleteTransactions(transIDString: string) {
    return this.http.post("/Admin/DeleteTransactions", {
      transIDString: transIDString,
    }).toPromise();
  }

  deleteTrans(importID: any) {
    return this.http.post("/Admin/DeleteTrans", {
      importID: importID,
    }).toPromise();
  }

  uploadTrans(importID: any, expenseTransIDToRemove: string) {
    return this.http.post("/Admin/UploadTrans", {
      importID: importID,
      expenseTransIDToRemove: expenseTransIDToRemove
    }).toPromise();
  }

  getImportTrans(importID?: any) {
    var url = "/Admin/GetImportTrans?importID=" + importID;
    return this.http.get(url).toPromise();
  }

  getApprovalHistoryByCreditCard(expenseTransID?: number) {
    var url = "/Admin/GetApprovalHistoryByCreditCard?expenseTransID=" + expenseTransID;
    return this.http.get(url).toPromise();
  }

  getReportManage(bulletinTypeID?: number, repostInstanceID?: number) {
    var url = "/Admin/GetReportManage?bulletinTypeID=" + bulletinTypeID + "&repostInstanceID=" + repostInstanceID;
    return this.http.get(url).toPromise();
  }

  getReportCatList() {
    var url = "/Admin/GetReportCatList";
    return this.http.get(url).toPromise();
  }

  updateBulletinReport(reportInstanceID?: number, reportInstanceName?: string, bulletinTypeID?: number, reportServerItemID?: number, sendXML?: any, showParametersOnReport?: boolean) {
    return this.http.post("/Admin/UpdateBulletinReport", {
      reportInstanceID: reportInstanceID,
      reportInstanceName: reportInstanceName,
      bulletinTypeID: bulletinTypeID,
      reportServerItemID: reportServerItemID,
      sendXML: sendXML,
      showParametersOnReport: showParametersOnReport
    }).toPromise();
  }

  deleteBulletinReport(reportInstanceID: number) {
    return this.http.post("/Admin/DeleteBulletinReport", {
      reportInstanceID: reportInstanceID
    }).toPromise();
  }

  async getUserAccessPageData(): Promise<UserAccessPageData> {
    return this.http.get<UserAccessPageData>('/Admin/GetUserAccessPageData').toPromise();
  }

  downloadTrainingClassRoster(TrainingClassID: string): Observable<ReportGenerationApiResponse> {
    return this.http.get<ReportGenerationApiResponse>(`/Admin/DownloadTrainingClassRoster?TrainingClassID=${TrainingClassID}`);
  }

  downloadLicenseDetails(): Observable<ReportGenerationApiResponse> {
    return this.http.get<ReportGenerationApiResponse>('/Admin/DownloadLicenseDetails');
  }

  downloadPaperConsent(): Observable<ReportGenerationApiResponse> {
    return this.http.get<ReportGenerationApiResponse>('/Admin/DownloadPaperConsent');
  }

  downloadEmployeeGroupDetail(userPRCo: number, userEmployee: number): Observable<ReportGenerationApiResponse> {
    return this.http.get<ReportGenerationApiResponse>(`/Admin/DownloadEmployeeGroupDetail?PRCO=${userPRCo}&Employee=${userEmployee}`);
  }

  downloadAuditLog(): Observable<ReportGenerationApiResponse> {
    return this.http.get<ReportGenerationApiResponse>('/Admin/DownloadAuditLog');
  }
}

export interface NamedLogin {
  UserKeyID: number
  IsUserLockedOut: boolean
  NamedLogin: string
}

export interface Vendor {
  APVMKeyID: number
  Vendor: number
  VendorName: string
  FullName: string
  VendorGroup: number
}

export interface PRGroup {
  PRGroup: number
  PRGroupName: string
}

export interface CompanyHQCo {
  CompanyName: string
  HQCo: number
  Label?: string
}

export interface ActiveLicenseCounts {
  userCount: number //HR
  reviewerCount: number //FC
  fieldUserCount: number //FM
  fieldServiceCount: number //FS
}

export interface ProvisionedLicenseCounts {
  HRManagementCount: number //HR
  FinancialControlsCount: number //FC
  FieldMgmtCount: number //FM
  FieldServiceCount: number //FS
}

export interface EmployeeGroup {
  FilterInactives: boolean
  NumberOfEmployees: number
  SQLOverride: string
  UserGroupID: number
  UserGroupName: string
}

export interface ReviewerGroup {
  ReviewerGroup: string
  GroupDescription: string
}

export interface HRUser {
  Employee: number
  FullName: string
  HRCo: number
  KeyID: number
  PRCO: number
}

export interface UserAccessPageData {
  TIDIsActive: boolean
  ActiveLicenseCounts: ActiveLicenseCounts
  ProvisionedLicenseCounts: ProvisionedLicenseCounts
  Companies: CompanyHQCo[]
  EmployeeGroups: EmployeeGroup[]
}

export interface User {
  ActiveYN: string | null
  ConsentACA1095: boolean | null
  ConsentACA1095LastModified: Date | null
  ConsentConfirmedOn: Date | null //Dateoffset
  ConsentPaystubs: boolean | null
  ConsentPaystubsLastModified: Date | null//Dateoffset
  ConsentW2T4: boolean | null
  ConsentW2T4LastModified: Date | null//Dateoffset
  DefaultFridayHours: number | null
  DefaultWorkHours: number | null
  Email: string | null
  EmailSource: string | null
  Employee: number | null
  EmployeeName: string | null
  EnableWelcomeEmail: boolean | null
  ExpenseAPVMKeyID: number | null
  ExpenseLast4CreditCard: string | null
  ExpenseReviewerGroup: string | null
  ExpenseReviewerGroupDescription: string | null
  ExpenseVendorName: string | null
  HRUserExists: boolean | null
  IsAuthARTrack: boolean | null
  IsAuthAlloc: boolean | null
  IsAuthBilling: boolean | null
  IsAuthBillingComp: boolean | null
  IsAuthBillingCompNew: boolean | null
  IsAuthCheck: boolean | null
  IsAuthChecklist: boolean | null
  IsAuthCrew: boolean | null
  IsAuthDTR: boolean | null
  IsAuthDailyReports: boolean | null
  IsAuthEarnings: boolean | null
  IsAuthEquipInfo: boolean | null
  IsAuthEquipTransfer: boolean | null
  IsAuthExpense: boolean | null
  IsAuthFMGridTime: boolean | null
  IsAuthFMMobile: boolean | null
  IsAuthFieldService: boolean | null
  IsAuthHRActionItems: boolean | null
  IsAuthHuddles: boolean | null
  IsAuthIssues: boolean | null
  IsAuthLeave: boolean | null
  IsAuthMO: boolean | null
  IsAuthMeters: boolean | null
  IsAuthMobileKiosk: boolean | null
  IsAuthPO: boolean | null
  IsAuthPOPend: boolean | null
  IsAuthPOQuick: boolean | null
  IsAuthPORcv: boolean | null
  IsAuthPOReq: boolean | null
  IsAuthProgress: boolean | null
  IsAuthTimecard: boolean | null
  IsAuthTrainingMgr: boolean | null
  IsAuthUpdates: boolean | null
  IsAuthVistaData: boolean | null
  IsAuthWODashboard: boolean | null
  IsAuthWorkOrder: boolean | null
  IsJobEquipAlloc: boolean | null
  IsSystemAdmin: boolean | null
  IsTrainingClassInstructor: boolean | null
  IsUserConfirmed: boolean | null
  IsUserLockedOut: boolean | null
  IsVPIDLinked: boolean | null
  IsVistaSSOUser: boolean | null
  LastName: string | null
  LeaveReviewerGroup: string | null
  LeaveReviewerGroupDescription: string | null
  LoginCount: number | null
  LoginDate: Date | null //datetimeoffset
  ManagerFullName: string | null
  ManagerPREHKeyID: number | null
  OptOutSMS: boolean | null
  POLicenseType: string | null
  PRCo: number | null
  PRGroup: number | null
  PRManagerUserGroupID: number | null
  PRManagerUserGroupName: string | null
  PRManagerUserKeyID: number | null
  PRManagerUserName: string | null
  Reviewer: string | null
  RowNum: number | null
  Rownumber: number | null
  Total: number | null
  TotalRows: number | null
  UserKeyID: number | null
  VPUserName: string | null
}

export interface UserArray {
  users: User[]
  totalRows: number
}

export interface UserGroup {
  FilterInactive: boolean
  NumberOfEmployees: number
  SQLOverride: string
  UserGroupID: number
  UserGroupName: string

}